const users = [
  {
    path: 'users',
    name: 'users',
    icon: 'cil-user',
    meta: {
      requiredRole: ['admin', 'middleAdmin', 'lowAdmin']
    },
    children: [
      {
        path: '',
        name: 'users_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/user/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin']
        }
      },
      {
        path: ':id',
        name: 'user_edit',
        components: {
          content: () => import('@/views/pages/user/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin']
        }
      },
      {
        path: 'new',
        name: 'user_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/user/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'users'
        }
      },
      {
        path: 'deleted',
        name: 'users_deleted',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/user/DeletedList.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin']
        }
      },
      {
        path: 'inactive-users',
        name: 'inactive_users',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/inactive_users/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'users'
        }
      },
      {
        path: 'approve/indirect',
        name: 'approve_indirect',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/approve/indirect/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'approve-indirect'
        }
      },
      {
        path: 'customer-numbers-to-approve',
        name: 'customer_numbers_to_approve',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/cs-numbers-to-approve/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'customer-numbers-to-approve'
        }
      },
      {
        path: 'customer-numbers-assistant',
        name: 'customer_numbers_assistant',
        showInMenu: true,
        components: {
          content: () => import('@/plugins/customer-numbers-assistant/view/Pages/CustomerNumbersAssistant.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'customer-numbers-assistant'
        }
      },
      {
        path: 'points-list',
        name: 'points_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/points/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'points-list'
        }
      },
      {
        path: 'kickback-list',
        name: 'kickback_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/points/KickbackList.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'kickback_list'
        }
      },
      {
        path: 'kickback-payout',
        name: 'kickback_payout',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/user/KickbackPayout.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'kickback-payout'
        }
      },
      {
        path: 'in-active-cs-nr',
        name: 'in_active_cs_nr',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/in_active_cs_nr/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'in-active-cs-nr'
        }
      },
      {
        path: 'milestone-users',
        name: 'milestone_users',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/milestone-users/List.vue')
        },
        meta: {
          requiredRole: ['admin'],
          moduleSlug: 'milestone-users'
        }
      },
      {
        path: 'shop-limits',
        name: 'shopLimits',
        icon: 'cil-vector',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/shop_limits/List.vue')
        },
        meta: {
          requiredRole: ['admin'],
          moduleSlug: 'shop-limits'
        }
      },
      {
        path: 'users/shop-user-stats',
        name: 'shop_user_stats_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/user/ShopUserStatsList.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin', 'lowAdmin'],
          moduleSlug: 'shop-stats'
        }
      }
    ]
  },
  {
    path: 'permissions',
    name: 'perms',
    icon: 'cil-vector',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/Permissions.vue')
    },
    meta: {
      requiredRole: ['admin'],
      moduleSlug: 'permissions'
    }
  },
  {
    path: 'booster-importer',
    name: 'booster_ccs_importer',
    icon: 'cil-group',
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      moduleSlug: 'booster-ccs'
    },
    children: [
      {
        path: '',
        name: 'booster_importer_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/commands/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'booster-ccs'
        }
      },
      {
        path: 'booster-importer-form',
        name: 'booster_importer_form',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/commands/BoosterImporter.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
          moduleSlug: 'booster-ccs'
        }
      }
    ]
  },
  {
    path: 'wholesaler_management',
    name: 'wholesaler_management',
    icon: 'cil-group',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/wholesaler_management/List.vue')
    },
    meta: {
      requiredRole: ['admin'],
      moduleSlug: 'wholesaler-management'
    }
  },

  {
    path: 'groups',
    name: 'groups',
    icon: 'cil-group',
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
      moduleSlug: 'groups'
    },
    children: [
      {
        path: '',
        name: 'groups_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/groups/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin']
        }
      },
      {
        path: ':id',
        name: 'group_edit',
        components: {
          content: () => import('@/views/pages/groups/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin']
        }
      },
      {
        path: 'new',
        name: 'group_new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/groups/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin']
        }
      }
    ]
  },

  {
    path: 'customer-groups',
    name: 'customer-groups',
    icon: 'cil-group',
    meta: {
      requiredRole: ['admin'],
      moduleSlug: 'customer-groups'
    },
    children: [
      {
        path: '',
        name: 'customer-groups-list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/customer-groups/List.vue')
        },
        meta: {
          requiredRole: ['admin'],
          moduleSlug: 'customer-groups'
        }
      },
      {
        path: ':id',
        name: 'customer-groups-edit',
        components: {
          content: () => import('@/views/pages/customer-groups/Edit.vue')
        },
        meta: {
          requiredRole: ['admin'],
          moduleSlug: 'customer-groups'
        }
      },
      {
        path: 'new',
        name: 'customer-groups-new',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/customer-groups/New.vue')
        },
        meta: {
          requiredRole: ['admin'],
          moduleSlug: 'customer-groups'
        }
      }
    ]
  },

  {
    path: 'login-history',
    name: 'history',
    icon: 'cil-group',
    meta: {
      requiredRole: ['admin'],
      moduleSlug: 'login-history'
    },
    children: [
      {
        path: '',
        name: 'history_list',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/login_history/List.vue')
        },
        meta: {
          requiredRole: ['admin']
        }
      },
      {
        path: '',
        name: 'history_hour',
        showInMenu: true,
        components: {
          content: () => import('@/views/pages/login_history/List.vue')
        },
        meta: {
          requiredRole: ['admin']
        }
      },
      {
        path: ':id',
        name: 'history_view',
        components: {
          content: () => import('@/views/pages/login_history/View.vue')
        },
        meta: {
          requiredRole: ['admin']
        }
      }
    ]
  }
]

export default users
